import { LoadTender } from '@api/Trinium/Endpoints/EDI/types';
import Tag from '@components/Tag';
import classNames from 'classnames/bind';
import { Tooltip } from '@mui/material';
import RejectReasonsTooltip from './RejectReasonsTooltip';

import cellStyles from '../../RenderCell.module.css';
const cellStylesContext = classNames.bind(cellStyles);
import styles from '../EdiDataGrid.module.css';
const stylesContext = classNames.bind(styles);

export default function EdiStatusCell({ row }: { row: LoadTender }) {
	return (
		<>
			<Tooltip title={<RejectReasonsTooltip row={row} />}>
				<span
					className={cellStylesContext({
						['stacked-text-cell-primary-slot']: true,
						bold: true,
						error: row.status.toLowerCase() === 'error'
					})}
				>
					{row.status}
				</span>
			</Tooltip>
			<Tag
				text={row.ediAction}
				className={stylesContext({
					'add-action': row.ediAction === 'Add',
					'cancel-action': row.ediAction === 'Cancel',
					'update-action': row.ediAction === 'Update'
				})}
				dense
			/>
		</>
	);
}
